<template>
  <div class="PRHome">
    <div id="top_warp" style="padding-top:24px;">
      <Header v-if="domain === 1"></Header>
      <ReportHeader v-else></ReportHeader>
      <router-view/>
    </div>
    <div>
      <Footer></Footer>
    </div>
    <loading v-show="loading"></loading>
    <LogAndReg ref="logAndReg" v-show="loginPop"></LogAndReg>
    <AllSilderPc ref="allSilder"></AllSilderPc>
  </div>
</template>

<script>
import Loading from "base/loading/loading";
import Footer from "base/footer/pageFooter2";
import Header from "base/header/pageHeader";
import ReportHeader from "base/header/ReportHeader";
import LogAndReg from "views/pc/login/LogAndReg";
import { mapGetters } from "vuex";
export default {
    name: 'PRHome',
    computed: {
        ...mapGetters([
            'loading',
            'loginPop'
        ])
    },
    data() {
        return {
            domain: 1
        }
    },
    mounted() {
      // console.log(window.location)
        if(window.location.hostname.indexOf('ke.capwhale.com')>=0){
          this.domain = 1
        } else if(window.location.hostname.indexOf('report.capwhale.com')>=0){
          this.domain = 2
        } else {
          this.domain = 3
        }
        var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?2cef12fec27a33676d219719fc229ee4";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
    },
    components: {
        Loading,
        Footer,
        Header,
        ReportHeader,
        LogAndReg
    }
}
</script>


<style lang="scss" type="text/scss">
@import url("../common/scss/common.scss");
.PRHome {
  min-height: 100vh;
  // height: 100vh;
  // overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // background-color: #F8F8F8FF;
}
// #top_warp::-webkit-scrollbar {
//     width: 4px;
// }
// #top_warp::-webkit-scrollbar-thumb {
//     border-radius: 2px;
//     background:rgba(229,229,229,1);
// }
// #top_warp::-webkit-scrollbar-track {
//     border-radius: 2px;
//     background: #fff;
// }
.el-message__icon{
  font-size: 14px;
}
// .PRHome::-webkit-scrollbar {
//     display: none;
// }

</style>
